module.exports = __webpack_public_path__ + "img/Group7.b7348efd.png";